import React, { Component } from 'react';
import { Link } from "react-router";

import './App.css';

import esnetLogo from './img/logo.png';
import githubLogo from './img/github.png';

class App extends Component {
  render() {
    return (
      <div className="App">

        <nav className="navbar navbar-inverse navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <a className="navbar-brand" href="#">
                React Axis
              </a>
            </div>
            <div id="navbar" className="navbar-collapse collapse">
              <ul className="nav navbar-nav navbar-right">
                <li>
                  <a href="http://www.es.net">
                    <img src={esnetLogo} alt="ESnet" width="32px" height="32px" /></a>
                </li>
                <li>
                  <a href="https://github.com/esnet/react-axis/">
                    <img src={githubLogo}  alt="Github" width="32px" height="32px" /></a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

            <div className="row">

                <div className="col-sm-3 col-md-2 sidebar">
                    <p />

                    <div className="sidebar-heading">GUIDES</div>

                    <ul className="nav nav-sidebar">
                        <li><Link to="/">Introduction</Link></li>
                    </ul>

                    <div className="sidebar-heading">Examples</div>

                    <ul className="nav nav-sidebar">
                        <li><Link to="/example/basic">Basic example</Link></li>
                        <li><Link to="/example/timezone">Timezone example</Link></li>
                        <li><Link to="/example/duration">Duration example</Link></li>
                        <li><Link to="/example/format">Format example</Link></li>
                    </ul>

                    <div className="sidebar-heading">API</div>

                    <ul className="nav nav-sidebar">

                        <li><Link to="/api/Axis">Axis</Link></li>
                        <li><Link to="/api/TimeAxis">TimeAxis</Link></li>
    
                    </ul>

                    <div className="sidebar-heading">Links</div>

                    <ul className="nav nav-sidebar">
                        <li><a href="https://github.com/esnet/react-timeseries-charts">GitHub</a></li>
                        <li><a href="https://www.es.net/">ESnet</a></li>
                        <li><a href="http://software.es.net/">Open Source</a></li>
                    </ul>

                    <div className="sidebar-heading">Related Projects</div>

                    <ul className="nav nav-sidebar">
                        <li><a href="http://software.es.net/react-timeseries-charts/">Charts library</a></li>
                    </ul>
                </div>

                <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
                    {this.props.children}
                </div>

            </div>
      
      </div>
    );
  }
}

export default App;





// WEBPACK FOOTER //
// ./src/website/App.js